import SupportAgent from '@mui/icons-material/SupportAgent'
import { ListItemButton, ListItemIcon, ListItemText } from '@vapor/material'

type ListBackofficeProps = {
  onClick: () => void
}

export const ListBackoffice = (props: ListBackofficeProps) => {
  return (
    <ListItemButton onClick={props.onClick}>
      <ListItemIcon>
        <SupportAgent fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={'Strumenti di supporto'} />
    </ListItemButton>
  )
}
